import { Reveal } from "@/components/Reveal";

const steps = [
  {
    number: "01",
    title: "Understand Your Position",
    description:
      "Learn how your current credit and financial profile may be viewed and understand the fundamentals affecting it.",
    testId: "edu-step-understand",
  },
  {
    number: "02",
    title: "Build Your Foundation",
    description:
      "Develop stronger habits, organization and financial awareness based on your situation and goals.",
    testId: "edu-step-build",
  },
  {
    number: "03",
    title: "Prepare for Opportunities",
    description:
      "Learn what may be required before pursuing personal or business funding opportunities.",
    testId: "edu-step-prepare",
  },
];

export const EducationFirst = () => (
  <section data-testid="education-first-section" className="bg-[#141419] py-14 lg:py-20">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <Reveal>
        <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#D8B54A]" data-testid="education-first-label">
          Education First
        </p>
        <h2
          data-testid="education-first-heading"
          className="mt-3 font-heading text-2xl font-bold tracking-tight text-[#F2EEE3] sm:text-3xl lg:text-4xl"
        >
          We Don't Just Tell You What To Do.{" "}
          <span className="text-[#D8B54A]">We Teach You Why.</span>
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[#B8B2A6] sm:text-lg">
          J11 Consulting was built around education and mentorship.
        </p>
        <p className="mt-4 text-base leading-relaxed text-[#B8B2A6] sm:text-lg">
          Our goal is to help clients understand their financial position, learn the factors that may
          affect their opportunities and develop the knowledge needed to make stronger financial
          decisions independently.
        </p>
      </Reveal>
      <div className="flex flex-col gap-5">
        {steps.map((step, i) => (
          <Reveal key={step.number} delay={i * 0.1}>
            <div
              data-testid={step.testId}
              className="flex gap-5 rounded-2xl border border-white/10 bg-[#17171C] p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-black/40 sm:p-7"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#08080A] font-heading text-base font-bold text-white">
                {step.number}
              </span>
              <div>
                <h3 className="font-heading text-lg font-semibold tracking-tight text-[#F2EEE3]">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#B8B2A6]">{step.description}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
